// Základní URL PHP backendu.
// Nastav v .env souboru (viz .env.example), nebo uprav rovnou zde.
const API_BASE = process.env.REACT_APP_API_URL || 'https://hugoknives.cz/admin-api';

async function parseJsonSafe(res) {
  const text = await res.text();
  try {
    return JSON.parse(text);
  } catch (e) {
    throw new Error('Server nevrátil platná data (zkontroluj REACT_APP_API_URL).');
  }
}

// "credentials: include" je nutné, aby se s každým požadavkem posílala
// přihlašovací cookie (session) - i mezi různými doménami.

export async function getStatus() {
  const res = await fetch(`${API_BASE}/status.php`, { credentials: 'include' });
  return parseJsonSafe(res);
}

export async function login(password) {
  const res = await fetch(`${API_BASE}/login.php`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password }),
  });
  return parseJsonSafe(res);
}

export async function logout() {
  const res = await fetch(`${API_BASE}/logout.php`, {
    method: 'POST',
    credentials: 'include',
  });
  return parseJsonSafe(res);
}

export async function fetchImages() {
  const res = await fetch(`${API_BASE}/list.php`, { credentials: 'include' });
  return parseJsonSafe(res);
}

export async function deleteImage(name) {
  const res = await fetch(`${API_BASE}/delete.php`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name }),
  });
  return parseJsonSafe(res);
}

export async function uploadImages(files) {
  const formData = new FormData();
  files.forEach((file) => formData.append('images[]', file));

  const res = await fetch(`${API_BASE}/upload.php`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });
  return parseJsonSafe(res);
}
